exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_timeEditTable_2bH3ZzNIBKjHlpZypCPRlv tbody tr td {\n  padding: 0.5% !important;\n}\n\n.IA_timeEditTable_2bH3ZzNIBKjHlpZypCPRlv tbody tr td:last-child {\n  text-align: right;\n}\n\n.IA_timeEditTable_2bH3ZzNIBKjHlpZypCPRlv tbody tr td:last-child,\n.IA_timeEditTable_2bH3ZzNIBKjHlpZypCPRlv tbody tr td:first-child {\n  vertical-align: top;\n}", ""]);

// Exports
exports.locals = {
	"IA_timeEditTable": "IA_timeEditTable_2bH3ZzNIBKjHlpZypCPRlv"
};